import React from 'react'

import { compile } from '~/apps/ninesegsAnalyzer/routes/paths'
import { BetterLink } from '~/components/features/BetterLink'

import { useBrandAccountId } from '../hooks/useBrandAccountId'
import { type StrategyMemo } from '../hooks/useStrategyMemosInfiniteQuery'

export type TitleCellProps = {
  dataItem: StrategyMemo
}

export const TitleCell = ({ dataItem: strategyMemo }: TitleCellProps) => {
  const brandAccountId = useBrandAccountId()
  const to = React.useMemo(
    () =>
      compile('strategyMemoEdit', {
        brandAccountId,
        strategyMemoId: strategyMemo.id,
      }),
    [brandAccountId, strategyMemo.id],
  )

  return (
    <td>
      <BetterLink logEventName="Open customer strategy" to={to}>
        {strategyMemo.title}
      </BetterLink>
    </td>
  )
}
